// extracted by mini-css-extract-plugin
export default {"aboutHeader":"ForBuyersHeader_aboutHeader__1y0pA"};